export function timeout(delay?: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, delay));
}
